import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { WorkflowEditPage } from 'src/modules/tools/components/pages/workflow-edit.page';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const pathParamsSchema = z.object({
  workflowId: z.string(),
});

export const Route = createFileRoute('/tools/workflows/$workflowId/edit')({
  component: WorkflowEditComponent,
  validateSearch: (search) =>
    globalSearchSchema
      .merge(
        z.object({
          phoneVersion: globalSearchSchema.shape.phoneVersion.default(
            'v1' as const
          ),
        })
      )
      .parse(search),
  params: {
    parse: (params) => pathParamsSchema.parse(params),
  },
});

function WorkflowEditComponent() {
  const { workflowId } = Route.useParams();
  return (
    <AuthenticateRoute>
      <WorkflowEditPage workflowId={workflowId} />
    </AuthenticateRoute>
  );
}

export default Route;
